import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 10.5h14a2 2 0 0 1 1.75 1.031.999.999 0 0 0-.305.137l-8.445 5.63-8.445-5.63a1 1 0 0 0-.305-.137A2 2 0 0 1 10.5 10.5Zm-2 3.202V22.5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8.798l-8.445 5.63a1 1 0 0 1-1.11 0L8.5 13.702Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgEmail;